import {useReachGoalCallback} from '@logistics-frontend/blocks'
import {useCallback} from 'react'

import {BannerView, METRIKA_GOALS} from '../PromoBanner.consts'
import {usePromoBannerContext} from '../PromoBanner.context'
import {usePromoBannerAppLinkByVew} from '../PromoBanner.hooks'
import {Props} from './PromoBannerButton.types'

export const useDownloadAppCallback = (bannerView: BannerView, promoCode?: string) => {
  const appLink = usePromoBannerAppLinkByVew(bannerView, promoCode)

  return useCallback(() => {
    window.open(appLink, '_blank')
  }, [appLink])
}

export const useActionButton = ({action, text, promoCode, bannerView = BannerView.WITH_LEAD_BUTTON}: Props) => {
  const {onClosePopupScreen, onOpenPopupScreen} = usePromoBannerContext()
  const appLink = usePromoBannerAppLinkByVew(bannerView, promoCode)
  const reachGoalCallback = useReachGoalCallback()

  const getApplicationCallback = useDownloadAppCallback(bannerView, promoCode)

  const goToAppAction = useCallback(
    event => {
      event.stopPropagation()

      window.open(appLink, '_blank')
      reachGoalCallback(METRIKA_GOALS.COPIED_COUPON_BANNER_GO_TO_APP_CLICK)
      onClosePopupScreen()
    },
    [appLink, onClosePopupScreen, reachGoalCallback],
  )

  const closeAction = useCallback(
    event => {
      event.stopPropagation()

      onClosePopupScreen()
    },
    [onClosePopupScreen],
  )

  const copyAction = useCallback(
    async event => {
      event.stopPropagation()

      await window.navigator.clipboard.writeText(text)
      reachGoalCallback(METRIKA_GOALS.INSTALL_BANNER_WITH_PROMO_PROMO_CODE_CLICK)
      onOpenPopupScreen()
    },
    [reachGoalCallback, onOpenPopupScreen, text],
  )

  const getAppAction = useCallback(
    event => {
      event.stopPropagation()

      getApplicationCallback()
    },
    [getApplicationCallback],
  )

  switch (action) {
    case 'close':
      return closeAction
    case 'go-to-app':
      return goToAppAction
    case 'copy-coupon':
      return copyAction
    case 'get-app':
    default:
      return getAppAction
  }
}
